import { RfqTemplate } from '@lune-fe/dapi-models'
import { useQuery } from 'react-query'

import { getRfqTemplates } from 'endpoints/dapi'
import { queryKeys } from 'queryKeys'
import { TypedDapiRfqTemplate } from 'views/CalculateEmissions/RFQ/utils/types'
import {
    fixRfqMappingNoInterceptor,
    migrateOldVersionMappings,
} from 'views/CalculateEmissions/RFQ/utils/utils'

const LIMIT = 100

const useMappings = (sheetType: RfqTemplate['sheetType']) => {
    const {
        isLoading: loading,
        data: mappings = [],
        refetch,
    } = useQuery<TypedDapiRfqTemplate[]>([queryKeys.GET_MAPPING_TEMPLATE, sheetType], async () => {
        let hasMoreLocal = true
        let after: string | undefined
        let templates: TypedDapiRfqTemplate[] = []
        while (hasMoreLocal) {
            const response = await getRfqTemplates({ sheetType, limit: LIMIT, after })
            const { data, hasMore, nextCursor } = response
            const cleanedData = data.map(fixRfqMappingNoInterceptor)
            hasMoreLocal = hasMore && Boolean(nextCursor)
            after = nextCursor ?? undefined
            templates = [...templates, ...cleanedData]
        }
        return templates.map(migrateOldVersionMappings)
    })

    return {
        refetch,
        loading,
        mappings,
    }
}

export default useMappings
